"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { useHomePath } from "@/hooks/useHomePath";
import { useAppModeStore } from "@/stores/appModeStore";

export default function RootPage() {
  const router = useRouter();
  const isAppMode = useAppModeStore((s) => s.isAppMode);
  const { path, ready } = useHomePath();
  useEffect(() => {
    if (!ready) return;
    // In app mode, slug-prefixed paths don't exist in the static
    // export route table. Use hard navigation so the middleware
    // can strip the prefix and serve the correct page.
    if (isAppMode) {
      window.location.replace(path);
    } else {
      router.replace(path);
    }
  }, [router, path, ready, isAppMode]);
  return null;
}
